<template>
  <Block :theme="theme" title="科室申报情况">
    <chart-bar @clickBar="clickBar" :colors="colors" :types="types" class="chart" :dataList="dataList"></chart-bar>
  </Block>
</template>

<script>
import ChartBar from '../cmp/bar'
import Block from '../cmp/block'

export default {
  components: {
    Block,
    ChartBar
  },
  props: {
    data: {
      type: Array
    },
    theme: {
      type: String
    }
  },
  methods: {
    clickBar (parm) {
      let submitOrgId = this.dataList[parm.dataIndex].id
      let key = 'submitOrgId' + submitOrgId
      this.$emit('chooseData', {
        __key: key,
        submitOrgId
      })
    }
  },
  computed: {
    colors () {
      return this.theme === 'orange' ? ['#FF9D6B', '#FFE369'] : ['#3776ED', '#37CBED']
    },
    types () {
      return ['金额']
    },
    dataList () {
      let orgMap = {}
      if (this.data) {
        this.data.forEach(v => {
          if (!orgMap[v.submitOrgId]) {
            orgMap[v.submitOrgId] = {
              id: v.submitOrgId,
              name: v.submitOrgName || '未指定',
              total: v.total || 0
            }
          } else {
            orgMap[v.submitOrgId].total += v.total
          }
        })
      }
      let data = Object.keys(orgMap).map(key => {
        let item = orgMap[key]
        item.data = []
        item.data.push(item.total || 0)
        return item
      })
      return data
    }
  }
}
</script>

<style scoped lang="less">
.chart {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
